<template>
  <LeadStatusesPage
    :title="__('Status recusado', 'settings')"
    :description="
      __(
        'Status que permitem finalizar a lead sem orçamento, eles precisam estar na lista de concluídos',
        'settings'
      )
    "
    param-id="lead_completed_without_value_statuses"
  />
</template>

<script>
import LeadStatusesPage from "@/components/Lead/Statuses/LeadStatusesPage.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  components: {
    LeadStatusesPage,
  },
};
</script>
